<template>
  <div class="events home-module">
    <div class="container" v-if="!isMobile">
      <ego-title :title="title"  :subtitle="subtitle" class="events-title"></ego-title>
      <!-- <img src="./assets/ego-events.png" alt=""> -->
      <div class="img-list">
        <a class="item" :href="item.url" v-for="(item, id) in events" :key="id" target="_blank">
          <img class="img-item" :src="item.imgUrl" alt="">
          <div class="text-wrap">
            <h4>{{item.title}}</h4>
            <p>{{item.con}}</p>
          </div>
        </a>
      </div>
      <div class="join-btn">
        <router-link to="/event" target="_blank">
          <tgoButton :use="'bg'">查看更多活动</tgoButton>
        </router-link>
      </div>
    </div>

    <div class="container" v-if="isMobile">
      <ego-title :title="title" :special="'special'" :subtitle="subtitle" class="events-title"></ego-title>
      <div class="img-list">
        <a class="item" :href="events[0].url" target="_blank">
          <img class="img-item" src="https://static001-test.geekbang.org/resource/image/df/a1/df73dc05707d106516e2daa188aee0a1.png" alt="">
          <div class="text-wrap">
            <h4>{{events[0].title}}</h4>
            <p>{{events[0].con}}</p>
          </div>
        </a>
        <a class="item" :href="events[2].url" target="_blank">
          <img class="img-item" src="https://static001-test.geekbang.org/resource/image/15/3a/1551f0d7c25efb9b2b9e94cb0032553a.png" alt="">
          <div class="text-wrap">
            <h4>{{events[2].title}}</h4>
            <p>{{events[2].con}}</p>
          </div>
        </a>
        <a class="item" :href="events[5].url" target="_blank">
          <img class="img-item" src="https://static001-test.geekbang.org/resource/image/59/52/59a1415cd4ccf0ed71dd2cac38890b52.png" alt="">
          <div class="text-wrap">
            <h4>{{events[5].title}}</h4>
            <p>{{events[5].con}}</p>
          </div>
        </a>
      </div>
      <div class="join-btn">
        <tgoButton :use="isMobile ? 'mobile bg' : 'bg'">查看更多活动</tgoButton>
      </div>
    </div>
  </div>
</template>
<script>
import egoTitle from '@/base/ego-title'
import tgoButton from '@/base/ego-button-new'

import weixinshare from '@/util/weixinshare'

export default {
  data () {
    return {}
  },
  props: ['isMobile', 'events'],
  components: {
    egoTitle,
    tgoButton
  },
  computed: {
    title () {
      return '高频活动，开拓视野'
    },
    subtitle () {
      if (this.isMobile) {
        return '通过 <span style="font-size:18px;color: #D7B375;font-weight: 500">10</span> 余种多维度的活动形式，深入解读热门话题，丰富行业观察视角，获取实践路径'
      } else {
        return '通过 <span style="font-size:24px;color: #D7B375;font-weight: 500">10</span> 余种多维度的活动形式，深入解读热门话题，丰富行业观察视角，获取实践路径'
      }
    },
    word () {
      return '查看更多活动'
    }
  },
  methods: {
    clickBtn () { if (window.ga) window.ga('send', 'event', '页面点击', '首页-高频活动') }
  },
  mounted () {
    weixinshare({
      title: 'TGO 鲲鹏会 | 最新活动动态',
      desc: '第一时间了解全球活动动态'
    })
  }
}
</script>
<style scoped lang='sass'>
@import '../../../style/bulma/app.sass'

.events
  background-color: #fff
    // height: 243vw
  .container
    display: flex
    flex-direction: column
    align-items: center
    width: 80vw
    +mobile
      width: 92vw
    .events-title
      width: 80%
      margin: 0 auto 70px
      +mobile
        width: 95%
        margin-bottom: 10px
    .img-list
      width: 1080px
      display: flex
      flex-wrap: wrap
      margin-bottom: 42px
      +mobile
        width: 100%
        margin-bottom: 14px
      .item
        display: block
        position: relative
        width: 23.8%
        margin-bottom: 1.5%
        box-sizing: content-box
        +mobile
          width: 100%
          margin: 0 0 10px
        .img-item
          display: block
          width: 100%
        .text-wrap
          position: absolute
          box-sizing: border-box
          bottom: 0
          left: 0
          width: 100%
          height: 32%
          padding: 13px
          background: rgba(0,0,0,.6)
          color: #fff
          +mobile
            background: rgba(0,0,0,.9)
            padding: 14px
          h4
            font-size: 17px
            line-height: 1
            padding-bottom: 6px
            +mobile
              font-size: 14px
          p
            font-size: 12px
            color: #c4c4c4
            font-weight: bold
      .item:nth-child(1)
        width: 49.1%
        +mobile
          width: 100%
      .item:nth-child(2),
      .item:nth-child(5)
        margin-left: 1.5%
        margin-right: 1.5%
        +mobile
          margin: 0 0 10px
      .item:nth-child(6)
        margin-right: 1.5%
    .events-button
      color: #333
      +mobile
        padding: 5px 40px
        border: 1px solid $primary
        border-radius: 30px
        color: $primary !important
        margin-bottom: 30px
.join-btn
  margin: 0 auto
  width: 350px
  +mobile
    width: 86%
</style>
